!((document, Drupal, $) => {
  'use strict';

  /**
   * Main theme JS
   */
  Drupal.behaviors.global = {

    attach: function(context) {
      // eslint-disable-next-line max-len
      $(context).find('.local-tasks').once('mainLocalTasks').each(function () {
        $('body').addClass('admin-local-tasks');
      });

      // eslint-disable-next-line max-len
      $(context).find('.uk-table').once('mainUIkitTable').each(function () {
        let resizeMaxWidth = '';
        let maxWidth = 840;
        if ($(this).width() > maxWidth) {
          resizeMaxWidth = ' resize-max-width';
        }
        // To make UIkit tables responsive
        $(this).wrap('<div class="uk-overflow-auto' + resizeMaxWidth + '"></div>');
      });

      // Scroll to top listener
      const $scrollOffset = 250;
      let $btn = $('#js-scroll-to-top');
      $(window).scroll(function() {
        $btn.toggleClass('uk-hidden', $(this).scrollTop() <= $scrollOffset);
      });

      $(document).ready(function () {
        // eslint-disable-next-line max-len
        $(context).find('#elca-woody-messages .status-message').once('statusMessage').each(function () {
          let alertSelector = '#elca-woody-messages .status-message .uk-alert';

          let $statusMessages = $(alertSelector);
          if ($statusMessages.length) {
            $('body').addClass('has-messages');

            $statusMessages.on('hide', function () {
              // When the 'hide' event is intercepted, the 'uk-alert' closed by
              // the user will still be present in the DOM.
              // So, when only 1 'uk-alert' exists, we can consider that all
              // alerts have been closed by the user.
              if ($(alertSelector).length === 1) {
                $('body').removeClass('has-messages');
              }
            });
          }
        });
      });
    },

  };

})(document, Drupal, jQuery);
